/**
 * @package dto
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class EditProviderData
 */
import { AbstractData } from '@/modules/backend/Dto/AbstractData';

export class EditProviderData extends AbstractData {
  public providerId!: number;

  public name?: string;

  public resourceIds?: number[];
}
